import React from "react"
import { Provider } from "react-redux"
import { setupStore } from "./store"
import { dependencies } from "./apis";

export type Dependencies = typeof dependencies;
const store = setupStore();

export default ({ element }) => <Provider store={store}>{element}</Provider>
